export default {
  MAX_ATTACHMENT_SIZE: 5000000
};



// WEBPACK FOOTER //
// ./src/configs/config.js